import React, {useEffect, useState, useRef} from 'react';
import clsx from 'clsx';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

/**
 * Select utilisé dans la NavBar
 * @param {*} props 
 */
export default function MenuItem (props){
    const wrapperRef = useRef(null);
    const [openItem, setOpenItem] = useState(false);
    const [items, setItems] = useState(props.items);
    const [title, setTitle] = useState(props.title);

    useEffect(() => {
      setItems(props.items);
      setTitle(props.title);
    }, [props.items, props.title]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpenItem(false);
      }
    } 

    const titleComponent = (open) => {
      return (<div className="menuTitle">
        {title}
        <div className="menuIconArrow">
          {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon /> }
        </div>
      </div>);
    }

    const getItems = () => {
      let itemsLi = [];
      if (items) {
        Object.keys(items).forEach(key => {
          itemsLi.push(<li key={key}><span onClick={(e) => items[key](e)}>{key}</span></li>)
        });
      }

      return itemsLi;
    }  

    return (       
        <div ref={wrapperRef} className={clsx("menuList", { "show": openItem })} onClick={() => setOpenItem(!openItem)}>
            {titleComponent(false)}
          <div className={clsx("menuItem", { "show": openItem })}>
            <ul>
              <li>{titleComponent(true)}</li>
              {getItems()}
            </ul>
          </div>
        </div>
    ); 
}

